import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import tabs from '@/components/Tabs.vue';
import tab from '@/components/Tab1.vue';
import Next from '@/components/Next.vue';
import Thumbnail from '@/components/Thumbnail.vue';
import Carousel from '@/components/Carousel.vue';
import CommonHeader from '@/components/CommonHeader.vue';
import CardList from '@/components/CardList.vue';
import axios from 'axios';
import Modal from '../components/Modal.vue';
import SpinnerHolder from '@/components/SpinnerHolder.vue';
import DirectoryService from '../services/DirectoryService';
import { BusinessType } from '@/models/Menu';
import { MainView } from '@/store/state';
import { getFile } from '@/services/StorageService';
let BeeMarket = class BeeMarket extends Vue {
    constructor() {
        super(...arguments);
        this.autoSelected = false;
        this.loading = false;
        this.modal = false;
        this.searchRest = '';
        this.by = 7;
        this.count = 0;
        this.infoBusiness = [];
        this.requestInfo = [];
        this.tags = undefined;
        this.img = [
            'https://firebasestorage.googleapis.com/v0/b/menu-digital-d285e.appspot.com/o/directorio%2Fenvios_a_15_pesos_.png?alt=media&token=ffd85f3e-14b3-4427-ab14-177a4a241f69',
            'https://firebasestorage.googleapis.com/v0/b/menu-digital-d285e.appspot.com/o/directorio%2FHechoMexico(1).png?alt=media&token=5012a297-213e-4e60-b97f-b11694275161',
            'https://firebasestorage.googleapis.com/v0/b/menu-digital-d285e.appspot.com/o/directorio%2FLluvia.png?alt=media&token=b2d07a27-abd6-4cc5-b3bd-ad593924867a',
            'https://firebasestorage.googleapis.com/v0/b/menu-digital-d285e.appspot.com/o/directorio%2Fcard-2.png?alt=media&token=b21c8d01-80fe-4081-b834-d1c84e6151bf',
            'https://firebasestorage.googleapis.com/v0/b/menu-digital-d285e.appspot.com/o/directorio%2Fredes.png?alt=media&token=f8f1ad68-59fe-482b-9652-99d4e5962ac8'
        ];
    }
    loadInfo() {
        this.loading = true;
    }
    hideSlide() {
        this.modal = false;
        this.autoSelected = false;
    }
    activator() {
        this.modal = true;
    }
    goToOrderOrProfile() {
        this.$store.state.user ? this.$router.push("/profile") : this.$router.push("/login");
    }
    getBusinessCategory(business) {
        if (this.tags) {
            const tagsByFilter = this.tags?.filter(tag => {
                return tag.name.toLowerCase().includes(this.searchRest.toLowerCase());
            });
            const busByBusCats = this.requestInfo.filter(bus => {
                const idTags = tagsByFilter.map(tag => tag.id);
                return bus.directory?.businessCategory.some(bu => idTags.indexOf(bu) >= 0);
            });
            busByBusCats
                ? business = business.concat(busByBusCats)
                : null;
            //Elimina la duplicidad en la concatenacion
            business = [...new Map(business.map(bus => [bus['id'], bus])).values()];
        }
        return business;
    }
    scroll() {
        const scrolledTo = document.querySelector('#the-end');
        if (scrolledTo && this.isScrolledIntoView(scrolledTo) && this.count > 0 && this.count < this.requestInfo.length) {
            this.infoBusiness.push(...this.requestInfo.slice(this.count, (this.count + this.by)));
            this.count += this.by;
        }
    }
    isScrolledIntoView(el) {
        const rect = el.getBoundingClientRect();
        const elemTop = rect.top;
        const elemBottom = rect.bottom;
        const isVisible = elemTop < window.innerHeight && elemBottom >= 0;
        return isVisible;
    }
    mounted() {
        if (document.querySelector('.app-container') != null) {
            document.querySelector('.app-container')?.addEventListener('scroll', this.scroll);
        }
    }
    get filterRest() {
        const business = this.infoBusiness.filter(bus => {
            return bus.name.toLowerCase().includes(this.searchRest.toLowerCase())
                && (bus.directory?.businessType === BusinessType.RESTAURANTS
                    || bus.directory?.businessType === BusinessType.GOURMET);
        });
        if (this.searchRest == '') {
            return business;
        }
        else {
            return this.getBusinessCategory(business);
        }
    }
    get filterGourmet() {
        const business = this.requestInfo.filter(bus => {
            return bus.name.toLowerCase().includes(this.searchRest.toLowerCase())
                && bus.directory?.businessType === BusinessType.GOURMET;
        });
        return business;
    }
    get filterExpress() {
        const business = this.requestInfo.filter(bus => {
            return bus.name.toLowerCase().includes(this.searchRest.toLowerCase())
                && bus.directory?.businessType === BusinessType.EXPRESS;
        });
        return business;
    }
    async getData() {
        try {
            const config = {
                params: {
                    delivery: true,
                    sameDay: true,
                    city: 'Cancún',
                    state: 'Quintana Roo'
                }
            };
            const response = await axios.get(`${process.env.VUE_APP_CATALOG}`, config);
            this.requestInfo = response.data;
            this.requestInfo.forEach(async (data) => {
                data.logo = await getFile(data.logo);
            });
            this.infoBusiness = this.requestInfo.slice(0, this.by);
            this.count = this.by;
            this.loading = false;
        }
        catch (err) {
            console.log(err);
        }
        this.$analytics.logEvent('view_item_list', {
            item_list_name: 'Directory',
        });
        this.autoSelected = true;
    }
    async created() {
        this.loading = true;
        await this.$store.dispatch('setMainView', MainView.DIRECTORY);
        this.tags = await DirectoryService.getBusinessTags();
        this.getData();
        this.$store.dispatch('changeCurrency', 'MXN');
        this.$store.dispatch('changeLanguage', 'spanish');
    }
    loadCarousel(photosURL) {
        const items = photosURL.map(i => ({ url: i }));
        return items;
    }
};
BeeMarket = __decorate([
    Component({
        components: {
            tabs,
            tab,
            Next,
            Thumbnail,
            Carousel,
            CommonHeader,
            CardList,
            Modal,
            SpinnerHolder
        }
    })
], BeeMarket);
export default BeeMarket;
